<script setup lang="ts">
const { t } = useI18n();
const { getCraftableItemById } = useCraftingController();
const appStateStore = useAppStateStore();
const merchant = appStateStore.currentMerchant;
const route = useRoute();
const title = ref<string>("");
const imageUrl = ref<string>("");

useSeoMeta({
  title: () => title.value,
  description: `${t("main.marketplaceSEO.description.collectibleDetail")}`,
  ogType: "website",
  ogTitle: () => title.value,
  ogDescription: `${t("main.marketplaceSEO.description.collectibleDetail")}`,
  ogUrl: "https://gfal.market",
  ogImage: () => imageUrl.value,
  twitterCard: "summary_large_image",
  twitterSite: "@GFAL_Official",
  twitterTitle: () => title.value,
  twitterDescription: `${t(
    "main.marketplaceSEO.description.collectibleDetail"
  )}`,
  twitterImage: () => imageUrl.value,
});

const setSEO = (item: CraftItem) => {
  if (item) {
    title.value = `${t(`${item.translationId}.title`)} ${t(
      `${item.translationId}.subtitle`
    )} | ${t(`main.merchant.${merchant}`)}`;
    imageUrl.value = getPortraitItemImage(item.imageId).replace("webp", "png");
  }
};

const { data: storeCraftable, status } = await useAsyncData(
  "getCraftableItemById",
  async () => {
    const id = route.params.id?.toString();
    if (!id) return {} as CraftItem;
    const response = await getCraftableItemById(id, merchant);
    return response;
  },
  {
    default() {
      return {} as CraftItem;
    },
    lazy: true,
  }
);

watch(
  storeCraftable,
  (newItem) => {
    if (newItem) setSEO(newItem);
  },
  { immediate: true }
);
</script>

<template>
  <NuxtLinkLocale
    class="flex items-center my-7 cursor-pointer text-neutral-300 hover:text-primary-500"
    :to="`/store/${merchant}`">
    <NuxtIcon
      name="mdi:chevron-left"
      class="h-5 w-5 shrink-0"
      aria-hidden="true" />
    <p class="text-xl font-bold">{{ $t("main.storeDetail.backToList") }}</p>
  </NuxtLinkLocale>
  <div
    v-if="status === 'pending' || !appStateStore.areTidsLoaded"
    class="flex items-center justify-center">
    <LoaderCardDetail />
  </div>
  <CardCraftableDetail
    v-else-if="status === 'success' && storeCraftable"
    :craftable="storeCraftable" />
  <CommonNotFoundItem v-else />
</template>
